

    module.exports = require('./DataZoomView').extend({

        type: 'dataZoom.select'

    });




//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/dataZoom/SelectZoomView.js
// module id = 1118
// module chunks = 0